import { getUserId } from '../../userLocalDetails';
import { getUserRole } from '../../userLocalDetails';


export const isShowProgressBar = (task) => {
  return task.status != 'DRAFT' && task.submissionCount >= 0;
};

export const isShowShareOption = (taskStatus) => {
  return taskStatus === 'PUBLISHED' || taskStatus === 'DRAFT';
};

export const isShowCopyLink = (taskStatus) => {
  return taskStatus === 'PUBLISHED';
};

export const isShowChangeDueTime = (teacherId, taskStatus) => {
  return taskStatus === "PUBLISHED" && getUserId() === teacherId;
};


export const isShowCloseTaskOption = (teacherId, status) =>{
    return getUserId() === teacherId && status === "PUBLISHED"
}
export const isShowChangePublishTime = (taskStatus) =>{
    return false
}

export const isShowPublishNow = (taskStatus) =>{
    return taskStatus === 'SCHEDULED'
}

export const isShowDeleteOption = (teacherId) => {
  return getUserId() === teacherId;
};

export const isShowRubricOutcomes = () => getUserRole() === 'TEACHER';

export const isShowUploadResponses = (taskStatus) => {
  // Show for all published tasks for teachers
  return getUserRole() === 'TEACHER' && taskStatus === 'PUBLISHED';
};
